if (!customElements.get('fp-product-rail')) {
  customElements.define('fp-product-rail',class extends HTMLElement {
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();
      const options={signal:this.controller.signal};
      this.track=this.querySelector('[data-fp-rail]');
      if(!this.track)return;
      const sync=()=>{
        const end=this.track.scrollWidth-this.track.clientWidth;
        this.querySelector('[data-fp-prev]').disabled=this.track.scrollLeft<=2;
        this.querySelector('[data-fp-next]').disabled=end-this.track.scrollLeft<=2;
      };
      this.querySelectorAll('[data-fp-direction]').forEach(button=>button.addEventListener('click',()=>{
        this.track.scrollBy({left:Number(button.dataset.fpDirection)*this.track.clientWidth*.85,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
      },options));
      this.track.addEventListener('scroll',sync,{...options,passive:true});
      this.observer=new ResizeObserver(sync);this.observer.observe(this.track);sync();
    }
    disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
  });
}
if(!customElements.get('fp-square-guide')){
  customElements.define('fp-square-guide',class extends HTMLElement{
    connectedCallback(){
      this.controller?.abort();this.controller=new AbortController();
      const sync=()=>{
        const picker=this.closest('.shopify-section')?.querySelector('variant-picker');
        const chosen=picker?.querySelector('input:checked')?.value||'';
        this.querySelectorAll('[data-size]').forEach(item=>item.dataset.selected=String(chosen.startsWith(item.dataset.size)));
      };
      document.addEventListener('variant:update',sync,{signal:this.controller.signal});
      document.addEventListener('change',sync,{signal:this.controller.signal});sync();
    }
    disconnectedCallback(){this.controller?.abort();}
  });
}
